<template>
  <div class="py-2" v-if="settings_workspaces_id">
    <label :for="label" class="block text-xss font-medium text-gray-700">{{ label }}</label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{ description }}
    </div>
    <Combobox v-model="selected">
      <div class="relative mt-1">
        <div class="relative">
          <!-- Botão para remover a seleção -->
          <ComboboxButton v-if="selected" @click="unSelected()" class="absolute inset-y-0 right-8 flex items-center pr-2 z-10">
            <XMarkIcon class="h-4 w-4 text-gray-500 hover:text-red-500 cursor-pointer" />
          </ComboboxButton>

          <ComboboxInput @focus="openDropdown"
            class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-500 sm:text-xss"
            :displayValue="(item) => item?.name || ''" @change="searchTo" />

          <ComboboxButton class="absolute inset-y-0 right-0 flex items-center pr-2">
            <ArrowsUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </ComboboxButton>
        </div>

        <TransitionRoot leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0"
          @after-leave="query = ''">
          <ComboboxOptions
            class="z-10 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-xss shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-xss">
            <div v-if="filteredDataRows.length === 0 && query !== ''"
              class="relative cursor-default select-none py-2 px-4 text-gray-700">
              Not found
            </div>

            <template v-for="item in filteredDataRows" :key="item.id">
              <ComboboxOption as="template" :value="item" v-slot="{ selected, active }" :disabled="item.parent">
                <template v-if="!item.parent">
                  <li @click="update(item)" class="relative cursor-pointer select-none py-2 pl-10 pr-4"
                    :class="{ 'bg-slate-600 text-white': active, 'text-gray-900': !active }">
                    <span class="truncate flex" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                      <div v-if="item.nivel" class="pr-2">
                        {{ nivel(item.nivel) }}
                      </div>
                      {{ item.name }}
                    </span>
                    <span v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-3"
                      :class="{ 'text-white': active, 'text-teal-600': !active }">
                      <CheckIcon class="h-5 w-5" aria-hidden="true" />
                    </span>
                  </li>
                </template>
                <template v-else>
                  <li class="relative cursor-default select-none py-2 pl-10 pr-4"
                    :class="item.nivel == 0 ? 'bg-gray-200' : 'bg-gray-100'">
                    <span class="truncate flex" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                      <div v-if="item.nivel" class="pr-2">
                        {{ nivel(item.nivel) }}
                      </div>
                      {{ item.name }}
                    </span>
                    <span v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-3"
                      :class="{ 'text-white': active, 'text-teal-600': !active }">
                      <CheckIcon class="h-5 w-5" aria-hidden="true" />
                    </span>
                  </li>
                </template>
              </ComboboxOption>
            </template>
          </ComboboxOptions>
        </TransitionRoot>
      </div>
    </Combobox>
    <p v-if="error" class="mt-2 text-xs text-rose-600">Departament is required </p>
  </div>
</template>


<script>


import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from '@headlessui/vue'

import { CheckIcon, ArrowsUpDownIcon, XMarkIcon } from '@heroicons/vue/24/solid'

export default {

  name: 'DropDownSearchDepartamentsForm',
  props: {
    label: String,
    description: String,
    settings_workspaces_id: String,
    settings_departaments_id: String,
    value: [String, Object, Boolean],
    error: String,
    required_user: Boolean,
  },
  data() {
    return {
      urlDepartaments: 'core/components/fields/departaments',
      dataRows: [],
      query: '',
      item: {},
      selected: '',
      selectedBackup: '',
      params: {
        settings_workspaces_id: '',
        required_user: this.required_user || false,
      },
    }
  },
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    TransitionRoot,
    CheckIcon,
    ArrowsUpDownIcon,
    XMarkIcon,
  },
  methods: {

    openDropdown() {

      // Forçar o foco e a abertura do Combobox
      this.$nextTick(() => {
        const comboboxInput = this.$el.querySelector('input');
        if (comboboxInput) {
          // Simular uma tecla de seta para baixo para abrir o dropdown
          comboboxInput.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowDown' }));
        }
      });
    },


    async getDepartaments() {
      await this.$ApiService.post(this.urlDepartaments, this.params).then(response => {
        this.dataRows = this.$DepartamentsFunctions.organizeDeptos(response.data);

        // Se apenas um departamento está disponível, selecione-o automaticamente
        if (this.dataRows.length === 1) {
          this.selected = this.dataRows[0];
          this.selectedBackup = this.dataRows[0];
          this.$emit('update:modelValue', this.selected.id);
        } else {
          // Departamento selecionado (value)
          this.dataRows.forEach((element) => {
            if (element.id == this.value) {
              this.selected = element;
              this.selectedBackup = element;
            }

            // Marca o departamento como pai se tiver filhos
            this.dataRows.forEach((child) => {
              if (child.recursive_id == element.id && child.id != element.id) {
                element.parent = true;
              }
            });
          });
        }
      });
    },



    searchTo($event) {
      this.query = $event.target.value
    },
    unSelected() {
      this.selected = '',
        this.$emit('update:modelValue', null);
    },

    update(item) {
      this.item = item
      this.$emit('update:modelValue', this.item.id);
    },

    nivel(nivel) {
      let seta = '|';
      if (nivel && nivel > 0) {
        for (let i = 0; i <= nivel; i++) {
          seta = seta + 'ㅤ';
        }
        seta = seta + '›';
      }
      else {
        seta = '•';
      }
      return seta
    },

    search(item) {
      return (item.name||"").toLowerCase().indexOf((this.query||"").toLowerCase()) > -1
    },

  },

  computed: {
    filteredDataRows() {

      // Impede que sejam mostrados dados (apenas não retorna nada)
      if (!this.dataRows) {
        return ''
      }



      let showName = true;
      let rows = [];
      let item = {};

      // Se passei um Depto ID é pq quero excluir departamentos


      if ((this.value && this.settings_departaments_id) || (this.selectedBackup && this.settings_departaments_id)) {

        for (let i = 0; i < this.dataRows.length; i++) {
          item = this.dataRows[i];

          if (item.nivel == 0) {
            if (item.id == this.value || item.id == this.selectedBackup.id) {
              showName = false;
            } else {
              showName = true;
              if (this.query) {
                if (this.search(item)) { rows.push(item); }
              }
              else {
                rows.push(item);
              }
            }
          }
          else {
            if (showName) {
              if (item.id == this.value || item.id == this.selectedBackup.id) {
                showName = false;
                if (this.query) {
                  if (this.search(item)) { rows.push(item); }
                }
                else { rows.push(item); }
              }
              else {
                if (this.query) {
                  if (this.search(item)) { rows.push(item); }
                }
                else { rows.push(item); }
              }
            }
          }
        }
        return rows;
      }

      // TODO: Resolver problema do departamento principal
      // (permite selecionar o departamento principal e outros sub departamentos
      return this.dataRows.filter(item => {
        if (this.search(item)) { return item.name }
      });

    },
  },

  watch: {
    settings_workspaces_id(newValue) {
      this.params.settings_workspaces_id = newValue;
      this.selected = '';
      this.params.required_user = this.required_user;
      this.$emit('update:modelValue', null);
      this.getDepartaments();
    },
  },

  created() {
    this.params.settings_workspaces_id = this.settings_workspaces_id;
    this.params.required_user = this.required_user;
    // aguarda 100ms 
    setTimeout(() => {
      this.getDepartaments();
    }, 100);
  },
}

</script>
